import { ReactElement } from 'react'

import { Popover, List, Tooltip } from 'antd'
import compact from 'lodash/compact'
import pluralize from 'pluralize'

import { Flex } from 'components/core'
import { userHasDashboardsOnlyPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions } from 'hooks'
import { LabelPageTabId } from 'routing/pageTabIds'
import { Label } from 'types'

import LabelColor from '../LabelColor'
import LabelElement from '../LabelElement'

import * as styles from './styles.scss'

interface Props {
    labels: Label[]
    linkToTab?: LabelPageTabId
}

const GroupedLabels = ({ labels, linkToTab }: Props): ReactElement => {
    const dashboardOnlyExperience = useUserHasPermissions(
        userHasDashboardsOnlyPermissions
    )

    const renderGroupedColors = (): ReactElement => {
        const groupedLabelsPreview = compact(
            labels.map((label, idx) => idx < 3 && label)
        )

        return (
            <Flex className={styles['label-group--wrapper']}>
                <div
                    style={{
                        width: groupedLabelsPreview.length * 9,
                        marginRight: 8,
                        position: 'relative',
                    }}
                    className={styles['label-group--color--wrapper']}
                >
                    {groupedLabelsPreview.map((label) => (
                        <div
                            key={label.id}
                            className={styles['label-group--color--border']}
                        >
                            <LabelColor color={label.color} />
                        </div>
                    ))}
                </div>
                <span>{pluralize('Label', labels.length, true)}</span>
            </Flex>
        )
    }

    return (
        <Popover
            content={
                <List
                    size="small"
                    split={false}
                    dataSource={labels}
                    style={{ padding: 8 }}
                    renderItem={(label, index) => (
                        <List.Item
                            style={{
                                marginTop: index !== 0 ? 8 : 0,
                                padding: 0,
                            }}
                        >
                            <Tooltip
                                title={label.description}
                                style={{ padding: 0, margin: 0 }}
                            >
                                <div>
                                    <LabelElement
                                        label={label}
                                        linkToTab={linkToTab}
                                        disabled={dashboardOnlyExperience}
                                    />
                                </div>
                            </Tooltip>
                        </List.Item>
                    )}
                />
            }
        >
            {renderGroupedColors()}
        </Popover>
    )
}

export default GroupedLabels
